import { useQuery } from "@tanstack/react-query";
import {
  fetchCustomerEmailTimeline,
  type EmailTimelineEntry,
} from "../api/crm";

/** Fetches the per-customer email engagement timeline (one entry per
 *  automated email sent, with derived status + counts). */
export function useCustomerEmailTimeline(id: string) {
  return useQuery({
    queryKey: ["crm", "email-timeline", id],
    queryFn: () => fetchCustomerEmailTimeline(id),
    staleTime: 60 * 1000, // 1 min — refresh more aggressively than full timeline
    gcTime: 5 * 60 * 1000,
    enabled: Boolean(id),
  });
}

export type { EmailTimelineEntry };
